module.exports = __webpack_public_path__ + "static/img/upgrade.e4a88b46.png";